import React from 'react';

/**
 * Emits per-product structured data for an app page:
 *  - SoftwareApplication: grounds the product as a distinct entity.
 *  - BreadcrumbList: Home > Product trail for richer SERP/AI context.
 *
 * `app` is a PRODUCTS entry from constants-products.js.
 */
const ProductSchema = ({ app }) => {
  if (!app) return null;

  const productUrl = `https://buddieshr.com/${app.urlSlug || app.slug}`;
  const logo = app.logoUrl
    ? `https://buddieshr.com${app.logoUrl}`
    : undefined;

  const softwareJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: app.fullName || app.name,
    url: productUrl,
    ...(logo ? { image: logo } : {}),
    description: app.shortDescription,
    operatingSystem: 'SLACK, Microsoft Teams',
    applicationCategory: 'BusinessApplication',
    publisher: {
      '@type': 'Organization',
      name: 'BuddiesHR',
      url: 'https://buddieshr.com/',
    },
    offers: {
      '@type': 'Offer',
      price: app.price != null ? app.price : 1,
      priceCurrency: 'USD',
      url: 'https://buddieshr.com/pricing',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://buddieshr.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: app.fullName || app.name,
        item: productUrl,
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
    </>
  );
};

export default ProductSchema;
